interface Auth0Identity {
  sub?: string;
}

/**
 * Whether Auth0 holds a password for this user. Database users have "auth0|"
 * ids; SSO users have "samlp|..." or "oidc|..." and change their password
 * with their company. The gateway applies the same rule before it emails a
 * reset link.
 */
export function hasAuth0Password(user?: Auth0Identity) {
  return user?.sub?.startsWith('auth0|') ?? false;
}
